import React from "react";

import Presentation from "./presentation";

const MobileTabs = ( {
	tabs,
	defaultTab,
	onClickHandler
} ) => {

	return (
		<Presentation
			defaultTab          = { defaultTab }
			onClickHandler      = { onClickHandler }
			tabs                = { tabs?.map ( item => ( { value: item.value.toString (), label: item.label } ) ) }
		/>
	);
};

export default MobileTabs;
